// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 6633 ? "admin-0a567896" : chunkId) + "." + {"4060":"058ff9ca","6633":"1e0f1d76"}[chunkId] + ".chunk.css";
};